<template lang="pug">
div(class="main-container" )
    consentModal(:consent='consent' :existingRecord='existingRecord')
    b-modal#modalPermission(centered, title="Allow Notifcations" hide-footer @show="permissionModalOpen = true" @hidden="permissionModalOpen = false")
                p(class="text-center") Click Allow for push notifcations from announcements and messages!
                div(class="d-flex justify-content-center")
                    b-button(class=" mt-4 px-5 shadow" variant="success" class="mt-3"  size="md" @click="requestPermission")
                        | Allow
    div(class="greeting-container w-100 d-flex p-2 " style="gap: 1rem; margin: 0 auto;")
        lottie-animation(:animation-data="timeOfDayGreet === 'Morning' ? sun : moon" :autoPlay="true" :loop="false" :speed="1" ref="anim"  class="w-25" v-if="!loadingImage && caregiverName")
        b-skeleton(height="100px" width="100px" variant="rect" class="w-25 ml-2 mt-2" v-else-if="loadingImage || !caregiverName")
        
        div(class="greet-text d-flex flex-column justify-content-center align-items-start w-75 p-2" v-if="caregiverName")
            h6(class="text-start greet-label") Good {{timeOfDayGreet}},
            h3(class="text-start greet-name") {{caregiverName}}
        div(class="name-skeleton d-flex flex-column justify-content-center align-items-start w-50 p-2" v-if="!caregiverName")
            b-skeleton(height="40px" width="100%" variant="rect")
            b-skeleton(height="40px" width="100%" variant="rect")
    
    div(class="dsg-image-container w-100 px-3")

        b-card(overlay :img-src="validImageUrl && validImageUrl" img-alt="Card Image" text-variant="white" class="hero-card" v-if="validImageUrl && !loadingImage")
            #card-overlay.d-flex.flex-column.justify-content-end.h-100
                span.hero-badge Family Of Wisdom
                h4.hero-title Welcome to DSG FOW


        div(v-else-if="loadingImage || !validImageUrl" class="d-flex flex-column w-100 h-100 px-3")
            b-skeleton(img class="skeleton-image" height="250px" width="100%" variant="rect")

    cara-membership(
        v-if="caregiverName && !loadingImage && !loadingAnnouncements"
        layout="home"
        :client-id="caraClientId"
        :caregiver-id="caraCaregiverId"
        :auto-prompt="canPromptCara"
    )


    b-alert.mx-3.mt-4.subscription-alert(
        v-if="hasNewSubscription && !loadingAnnouncements"
        variant="info"
        show

        @dismissed="dismissSubscriptionAlert"
        @click="goToSubscriptionPage"
        style="cursor: pointer;"
    )
        div(@click="goToSubscriptionPage" class="d-flex align-items-center justify-content-between")
            div(class="d-flex align-items-center")
                b-icon(icon="bell-fill" class="mr-2" scale="1.2")
                div
                    strong New Subscription Available
                    p.mb-0.small.text-muted Click to view details
            b-icon(icon="chevron-right" scale="1.2")

    b-alert.mx-3.mt-3.neeurofit-alert(
        v-if="hasNewNeeurofitReport && !loadingAnnouncements"
        variant="warning"
        show
        dismissible
        @dismissed="dismissNeeurofitAlert"
        @click="goToClientProfile"
        style="cursor: pointer;"
    )
        div(@click="goToClientProfile" class="d-flex align-items-center justify-content-between")
            div(class="d-flex align-items-center")
                b-icon(icon="file-earmark-bar-graph-fill" class="mr-2" scale="1.2")
                div
                    strong Neeurofit Report Available
                    p.mb-0.small Click to view in Client Profile
            b-icon(icon="chevron-right" scale="1.2")

    h5(class="mx-3 mt-4 mb-3 section-heading" v-if="!loadingAnnouncements") Announcements
    b-skeleton(height="40px"  variant="rect" v-else class="mx-3 mt-4 mb-3")
    div(v-if='caregiverName && !loadingAnnouncements && notificationOn !== "true"' class="notif-off-banner mx-3 my-3 d-flex align-items-center" @click="$router.push('/settings')")
        b-icon(icon="bell-slash-fill" class="notif-off-icon mr-3")
        div(class="flex-fill")
            h6.mb-0 Notifications are off
            small You may miss out announcements and other notifications. Tap to turn on.
        b-icon(icon="chevron-right" class="notif-off-chevron")
    div(class="w-100 p-3" v-if="!loadingAnnouncements")
        pinned-announcement(:pinned="pinned" :showModal.sync="showModal"  @update:selectedAnnouncement="showModalAnnouncement")
        b-button(class="go-to-announcement mt-2  w-100" variant="secondary" style="background-color:#8967b3;" @click="$router.push('/announcement')") View All Announcements
    div(v-else-if="loadingAnnouncements" class="d-flex justify-content-center align-items-center " style="width:92%; margin: 0 auto;")
        b-skeleton(height="100px" width="100%" variant="rect")
    b-modal(v-model="showModal" title="Announcement" size="is-large" scrollable)
        div(class="d-flex flex-column w-100")
            div(class="d-flex w-100 justify-content-between mt-2")
                h5 {{selectedAnnouncement?.crb5c_title}}
                p(class="date-announcement") {{new Date(selectedAnnouncement?.createdon).toLocaleDateString()}}
            div(class="image-gallery-container d-flex w-100 flex-column" v-if="selectedAnnouncement?.crb5c_images?.images?.length > 0" )
                    div(class="img-cont" v-for="image in selectedAnnouncement?.crb5c_images?.images" :key="image?.id")
                        img(:src="image?.url" class="w-100" alt="announcement image")
                        b-button(v-if="selectedAnnouncement?.crb5c_images?.imageDownloadable" @click="saveToDevice(image?.url)" variant="primary" class="mt-2") 
                            b-icon(icon="download")
            //- div(v-html="selectedAnnouncement?.crb5c_body ? JSON.parse(selectedAnnouncement?.crb5c_body) : ''" class="mt-4")
            div(v-html="processAnnouncementBody(selectedAnnouncement?.crb5c_body)" class="mt-4")

        template(v-slot:modal-footer)
            b-button(class="button is-success" @click="showModal = false") Close 
    b-modal(v-model="showOpeningPopup" title="Announcement" size="is-large" scrollable centered)
        div(class="d-flex flex-column w-100")
            div(class="d-flex w-100 justify-content-between mt-2")
                h5 {{popUpData?.crb5c_title}}
                p(class="date-announcement") {{new Date(popUpData?.createdon).toLocaleDateString()}}
            div(class="image-gallery-container d-flex w-100 flex-column" v-if="popUpData?.crb5c_images?.images?.length > 0" )
                    div(class="img-cont" v-for="image in popUpData?.crb5c_images?.images" :key="image?.id")
                        img(:src="image?.url" class="w-100" alt="announcement image")
                        b-button(v-if="popUpData?.crb5c_images?.imageDownloadable" @click="saveToDevice(image?.url)" variant="primary" class="mt-2") 
                            b-icon(icon="download")
            //- div(v-html="popUpData?.crb5c_body ? JSON.parse(popUpData?.crb5c_body) : ''" class="mt-4")
            div(v-html="processAnnouncementBody(popUpData?.crb5c_body)" class="mt-4")

        template(v-slot:modal-footer)
            b-button(class="button is-success" @click="showOpeningPopup = false") Close
    b-modal(v-model="showUnpaidSubscriptionPopup" :title='unpaidSubscriptionData?.crb5c_title' size="is-large" scrollable centered no-close-on-backdrop no-close-on-esc hide-header-close)
        div(class="d-flex flex-column w-100")
            
            div(class="d-flex flex-column w-100 gap-2 align-items-start")
                //- h5 {{unpaidSubscriptionData?.crb5c_title}}
                h5.my-2(class="text-danger font-weight-bold") IMPORTANT: PLEASE READ
                //- p.my-3.text-muted Please read through the information carefully and mark the checkbox below before tapping on Acknowledge.
                //- p(class="date-announcement small text-muted mb-1") Created On: {{ new Date(unpaidSubscriptionData?.createdon).toLocaleDateString() }}
            div(v-html="processAnnouncementBody(unpaidSubscriptionData?.crb5c_body)" class="mt-1")
            p.my-3.text-muted.small Check the box below to acknowledge.
            b-form-checkbox.my-2(v-if="!unpaidSubscriptionData?.subscriptionData?.isSubscribed" class="flex-fill" v-model='tcAcknowledgement' ) I have read and understood this information.
            
            b-form-checkbox.my-2(v-if="!unpaidSubscriptionData?.subscriptionData?.isSubscribed" class="flex-fill text-muted" v-model='sendEmailCopy' ) Send a copy to email (Optional)
            
            div(v-if="sendEmailCopy && !unpaidSubscriptionData?.subscriptionData?.isSubscribed" class="w-100 mt-2 mb-3")
                b-form-input(
                    v-model="recipientEmail"
                    type="email"
                    placeholder="Enter your email address"
                    :state="emailValidation"
                    size="sm"
                )
                b-form-invalid-feedback(:state="emailValidation")
                    | Please enter a valid email address
                small.text-muted(v-if="caregiverEmail && !recipientEmail") Default (Registered email): {{ caregiverEmail }}
    
        template(v-slot:modal-footer)
            div(v-if="unpaidSubscriptionData?.subscriptionData?.isSubscribed" class="d-flex flex-column align-items-center w-100")
                div(class="d-flex align-items-center mb-2")
                    b-icon(icon="check-circle-fill" variant="success" class="mr-2")
                    span(class="text-success") Already Acknowledged
            div(v-else class="d-flex gap-2 w-100")
                b-button(:disabled="!tcAcknowledgement || (sendEmailCopy && !isValidEmail)" class="flex-fill ml-2" variant="success" @click="acknowledgeFreeSubscription('yes')") 
                    | Acknowledge
    h5(class="mx-3 mt-4 mb-3 section-heading" v-if="!loadingAnnouncements") Quick Actions
    b-skeleton(height="40px"  variant="rect" v-else class="mx-3 mt-4 mb-3")
    div(class="quick-actions-container w-100   my-2 mb-5 px-4 d-flex align-items-center overflow-auto" style="gap: 1rem;" v-if="!loadingAnnouncements && caregiverName")
        quick-action-card(v-for="(action, index) in visibleQuickActions" :key="index" :action="action" )   
    div( class="d-flex align-items-center w-100 px-3 overflow-auto" v-else style="gap: 1rem;")
        b-skeleton(height="150px" max-width="150px" width="150px" variant="rect" v-for="action in quickActions" :key="action.name" class="quick-action-card position-relative d-flex flex-column justify-content-center align-items-center p-2 shadow-md" style="gap: 1rem; flex-shrink: 0;" )
</template>

<script>
import fowEligibility from '@/mixins/fowEligibility';
import PinnedAnnouncement from '@/components/PinnedAnnouncement.vue';
import LottieAnimation from 'lottie-web-vue'
import sunAnimation from "../assets/sunAnimation.json"
import moonAnimation from '../assets/moonAnimation.json'
import HomeCard from "@/components/home/HomeCard.vue";
import HomeList from "@/components/home/HomeList.vue";
import HomeClient from "@/components/home/HomeClient.vue";
import QuickActionCard from '@/components/QuickActionCard.vue';
import consentModal from '@/components/setting/consentPopUp.vue'
import CaraMembership from '@/components/CaraMembership.vue'
import axios from 'axios';
import { mapState } from "vuex";

export default {
    mixins: [fowEligibility],
    watch: {
        fowClientId: { immediate: true, handler() { this.ensureFowEligibility(); } },
    },
    components: {
        LottieAnimation,
        HomeCard,
        HomeList,
        HomeClient,
        QuickActionCard,
        PinnedAnnouncement,
        consentModal,
        CaraMembership
    },
    data() {
        return {
            existingRecord: '',
            consent: [],
            sun: sunAnimation,
            moon: moonAnimation,
            notificationOn: null,
            fetching: true,
            announcementCollapse: true,
            surveystatus: null,
            quickActions: [
                { name: 'Announcement', path: '/announcement', icon: 'megaphone',disabled:false },
                { name: 'Event', path: '/events', icon: 'calendar' },
                { name: 'Past Sessions', path: '/session', icon: 'book',disabled:false },
                { name: 'Make Up Session', path: '/make-up-session', icon: 'arrow-repeat', disabled: false },
                { name: 'Submit MC', path: '/submit-mc', icon: 'file-earmark-medical', disabled: false },
                { name: 'Contact Us', path: '/contact', icon: 'person', disabled:false},
                // {name: 'More Features Coming Soon', path: '/home', icon: 'star', disabled: true},
                // { name: 'Survey', path: '/survey', icon: 'clipboard' },
                // { name: 'Chat', path: '/messaging', icon: 'chat' },
            ],
            pinned: [],
            announcements: [],
            loadingAnnouncements: false,
            selectedAnnouncement: {
                    crb5c_title: "",
                    crb5c_body: "",
                    createdon: "",
                },
            showModal: false,
            existingImage: null,
            showOpeningPopup: false,
            popUpData: {},
            showUnpaidSubscriptionPopup: false,
            permissionModalOpen: false,
            unpaidSubscriptionData: {},
            tcAcknowledgement: false,
            sendEmailCopy: false,
            recipientEmail: '',
            hasNewSubscription: false,
            dismissedSubscriptionAlert: false,
            hasNewNeeurofitReport: false,
        }
    },
    methods: {
        truncateText(html, length) {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;
                const text = tempDiv.textContent || tempDiv.innerText || '';
                if (text.length > length) {
                
                    return text.substring(0, length) + "...";
                } else {
                
                    return html;
                }
            },
            processAnnouncementBody(body) {
                if (!body) return '';

                let parsedBody = JSON.parse(body);


                const clientId = this.$root.currentUser[0]?.crb5c_client?.crb5c_fow_customerid;

                if (!clientId) return parsedBody;

                const caregiverId = this.$root.currentUser[0]?.crb5c_fow_caregiverid;

                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = parsedBody;


                const links = tempDiv.querySelectorAll('a[href*="https://dsg-form.pages.dev/"]');

                links.forEach(link => {
                    const url = new URL(link.href);
                    url.searchParams.set('client_id', clientId);
                    if (caregiverId) url.searchParams.set('caregiver_id', caregiverId);
                    link.href = url.toString();
                });

                return tempDiv.innerHTML;
            },
        showModalAnnouncement(announcement){
                // console.log(announcement);
                this.selectedAnnouncement = announcement;
                // console.log(this.selectedAnnouncement);
                this.showModal = true;
            },

        async waitForCurrentUser(timeoutMs = 20000) {
            const startedAt = Date.now();
            while (!this.$store.state.currentUser[0]) {
                if (Date.now() - startedAt > timeoutMs) return false;
                await new Promise(resolve => setTimeout(resolve, 50));
            }
            return true;
        },

        async recordLoginVisit() {
            const currentUser = this.$store.state.currentUser[0];
            if (!currentUser) return;
            const currentDate = new Date();
            try {
                const response = await axios.get(`/api/records/${currentUser.crb5c_client.crb5c_fow_customerid}/${currentUser.crb5c_fow_caregiverid}`);
                const data = response.data;
                const payload = data?.length
                    ? { recordID: data[0].crb5c_fowmobilerecordsid, login: currentDate }
                    : {
                        client: currentUser.crb5c_client.crb5c_fow_customerid,
                        caregiver: currentUser.crb5c_fow_caregiverid,
                        login: currentDate,
                    };
                await axios.post(`/api/records/${currentUser.crb5c_fow_caregiverid}`, payload);
            } catch (errordata) {
                console.error('Error recording login visit', errordata);
            }
        },
        async loadAnnouncements() {
            try {
                const clientId = this.$root.currentUser[0]?.crb5c_client?.crb5c_fow_customerid;
                if (!clientId) return;

                const lastIDLocal = JSON.parse(localStorage.getItem('lastID'));
                const { data } = await axios.get(`/api/announcements/v2`, {
                    params: { userID: clientId, lastID: lastIDLocal }
                });
                const { pinned, general, lastID, popup } = data;
                this.announcements = general;
                this.pinned = pinned;
                if (popup?.length > 0 && lastIDLocal !== lastID) {
                    localStorage.setItem('lastID', JSON.stringify(lastID));
                    this.showOpeningPopup = true;
                    this.popUpData = popup[0];
                }
            } catch (err) {
                console.log(err);
            } finally {
                // Released as soon as announcements land rather than after every
                // other request on the page has finished.
                this.loadingAnnouncements = false;
            }
        },
        async checkConsentRecord() {
            const clientId = this.$root.currentUser[0]?.crb5c_client?.crb5c_fow_customerid;
            if (!clientId) return;
            try {
                const response = await axios.get(`/api/records/${clientId}`);
                if (!response.data || !response.data.length) {
                    this.$bvModal.show('modalConsent');
                }
            } catch (err) {
                console.error('Error checking consent record', err);
            }
        },
        async checkNotificationPermission(){
            try {
                const optedIn =  this.$OneSignal.User.PushSubscription.optedIn;
                const permission = this.$OneSignal.Notifications.permissionNative;
                // console.log('optedIn',optedIn)
                // console.log('permission',permission)
                // console.log('this.$store.state.currentUser[0]',this.$store.state.currentUser[0])
                const notificationStatus = optedIn && permission;
                localStorage.setItem("notificationEnabled", notificationStatus);

                if (this.$store.state.currentUser[0]) {
                    if(notificationStatus){
                        this.loginOnesignal();
                    }else{
                        this.showPermissionModal();
                    }
                }
            } catch (error) {
                console.error("Error checking for permission",error);
            }
        },
        showPermissionModal() {
            this.$bvModal.show('modalPermission');
        },
        refreshNotificationState() {
            // Read the real OneSignal state so the homepage banner never shows a
            // stale value (e.g. after toggling in Settings). Source of truth for the banner.
            try {
                const perm = this.$OneSignal?.Notifications?.permissionNative;
                const optedIn = this.$OneSignal?.User?.PushSubscription?.optedIn;
                if (perm === undefined && optedIn === undefined) return; // SDK not ready yet
                const on = !!optedIn && perm === 'granted';
                this.notificationOn = on ? 'true' : 'false';
                localStorage.setItem('notificationEnabled', on ? 'true' : 'false');
            } catch (e) {
                console.error('refreshNotificationState error', e);
            }
        },
        requestPermission() {
            this.$bvModal.hide('modalPermission');
            this.$OneSignal.Notifications.requestPermission()
                .then(result => {
                    console.log(result);
                    localStorage.setItem("notificationEnabled", true);
                    this.notificationOn = true;
                    this.loginOnesignal();
                }).catch(err => {
                    console.error('Error requesting permission',err);
                    localStorage.setItem("notificationEnabled", false);
                    this.notificationOn = false;
                });
        },
        async loginOnesignal(){
            try {
                const phone = this.$store.state.currentUser[0].crb5c_contactnumbermobile;
                if (!phone) {
                    alert('Please re-set your phone number with the administator');
                    console.error('No phone number');
                    return;
                }
                await this.$OneSignal.login(`${phone}`);
                // console.log('Logged-in with OneSignal');
            } catch (error) {
                console.error('Error logging in OneSignal',error);
            }
        },
        redirectSurveyPage() {
            this.$router.push(`/survey`)
        },
        async reloadImage() {
            if (!this.validImageUrl) {
                // console.log('fetching image');
                await this.$store.dispatch('fetchImage');
            }
        },
        async checkForNewSubscriptions() {
            try {
                if (!this.$root.currentUser[0]?.crb5c_client?.crb5c_fow_customerid) return;
                
                const { data } = await axios.get(`/api/subscriptions`, {
                    params: { userID: this.$root.currentUser[0].crb5c_client.crb5c_fow_customerid }
                });
                
                const activeSubscriptions = data.active || [];
                
                // Check if there are any unsubscribed or declined subscriptions
                const hasUnacknowledgedSubscriptions = activeSubscriptions.some(sub => {
                    const hasAmount = parseFloat(sub.crb5c_amount) > 0;
                    const isUnacknowledged = !sub.subscribed && !sub.declined;
                    return hasAmount && isUnacknowledged;
                });
                
                // Check for free subscriptions
                const hasFreeUnacknowledged = activeSubscriptions.some(sub => {
                    const isFree = parseFloat(sub.crb5c_amount) === 0;
                    const isUnacknowledged = !sub.subscribed;
                    return isFree && isUnacknowledged;
                });
                
                this.hasNewSubscription = (hasUnacknowledgedSubscriptions || hasFreeUnacknowledged) && !this.dismissedSubscriptionAlert;
            } catch (error) {
                console.error('Error checking for new subscriptions:', error);
            }
        },
        async loadFreeSubscriptions() {
            try {
                if (!this.$root.currentUser[0]?.crb5c_client?.crb5c_fow_customerid) return;
                
                const lastAcknowledgedId = JSON.parse(localStorage.getItem('lastFreeSubscriptionId') || 'null');
                
                const { data } = await axios.get('/api/subscriptions/unpaid-acknowledgment', {
                    params: { 
                        userID: this.$root.currentUser[0].crb5c_client.crb5c_fow_customerid,
                        lastAcknowledgedId: lastAcknowledgedId
                    }
                });
                
                const { freeSubscriptions, lastAcknowledgedId: newLastId } = data;
                
                if (freeSubscriptions && freeSubscriptions.length > 0) {
                    this.unpaidSubscriptionData = freeSubscriptions[0];
                    
                    const isNewSubscription = !lastAcknowledgedId || lastAcknowledgedId.id !== newLastId.id;
                    const isNotYetAcknowledged = !this.unpaidSubscriptionData.subscriptionData?.isSubscribed;
                    
                    if (isNewSubscription && isNotYetAcknowledged) {
                        this.tcAcknowledgement = false;
                        this.sendEmailCopy = false;
                        this.recipientEmail = '';
                        this.showUnpaidSubscriptionPopup = true;
                        localStorage.setItem('lastFreeSubscriptionId', JSON.stringify(newLastId));
                    }
                }
            } catch (error) {
                console.error('Error loading free subscriptions:', error);
            }
        },
        async acknowledgeFreeSubscription(action) {
            this.showUnpaidSubscriptionPopup = false;
            if (action === 'yes') {
                if (this.unpaidSubscriptionData?.subscriptionData?.isSubscribed) {
                    this.$bvToast.toast('You have already acknowledged this.', {
                        title: 'Already Acknowledged',
                        variant: 'info',
                        solid: true
                    });
                    this.tcAcknowledgement = false;
                    this.sendEmailCopy = false;
                    this.recipientEmail = '';
                    return;
                }
                
                try {
                    await this.subscribeToFreeSubscription();
                    if (this.sendEmailCopy) {
                        await this.sendAcknowledgementEmail();
                    }
                    this.tcAcknowledgement = false;
                    this.sendEmailCopy = false;
                    this.recipientEmail = '';
                } catch (error) {
                    console.error('Error processing acknowledgment:', error);
                    this.tcAcknowledgement = false;
                    this.sendEmailCopy = false;
                    this.recipientEmail = '';
                    return;
                }
            } else {
                this.tcAcknowledgement = false;
                this.sendEmailCopy = false;
                this.recipientEmail = '';
            }
            
            const acknowledgmentData = {
                subscriptionId: this.unpaidSubscriptionData?.subscriptionData?.originalSubscriptionId,
                action: action,
                timestamp: new Date().toISOString(),
                type: 'free_subscription_acknowledgment',
                emailSent: this.sendEmailCopy
            };
            
            const existingAcknowledgments = JSON.parse(localStorage.getItem('freeSubscriptionAcknowledgments') || '[]');
            existingAcknowledgments.push(acknowledgmentData);
            localStorage.setItem('freeSubscriptionAcknowledgments', JSON.stringify(existingAcknowledgments));
        },
        async subscribeToFreeSubscription() {
            try {
                const payload = {
                    crb5c_userid: this.$root.currentUser[0].crb5c_client.crb5c_fow_customerid,
                    subscriptionId: this.unpaidSubscriptionData?.subscriptionData?.originalSubscriptionId
                };
                
                const response = await axios.post('/api/subscriptions/subscribe', payload);
                console.log('Successfully acknowledged:', response.data);
                
                // Show success message
                this.$bvToast.toast('Successfully acknowledged!', {
                    title: 'Acknowledgment',
                    variant: 'success',
                    solid: true
                });
                
            } catch (error) {
                console.error('Error acknowledging:', error);
                this.$bvToast.toast('Error processing acknowledgment. Please try again.', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true
                });
                throw error;
            }
        },
        async sendAcknowledgementEmail() {
            try {
                const recipient = this.recipientEmail || this.caregiverEmail;
                
                if (!recipient) {
                    throw new Error('No email address provided');
                }
                
                const payload = {
                    to: recipient,
                    subject: this.unpaidSubscriptionData?.crb5c_title,
                    body: this.unpaidSubscriptionData?.crb5c_body,
                    caregiverName: this.caregiverName,
                    acknowledgedAt: new Date().toISOString()
                };
                
                await axios.post('/api/subscriptions/send-acknowledgement-email', payload);
                
                this.$bvToast.toast('Acknowledgement copy sent to added email!', {
                    title: 'Email Sent',
                    variant: 'success',
                    solid: true
                });
            } catch (error) {
                console.error('Error sending email:', error);
                this.$bvToast.toast('Failed to send email. Acknowledgement was still recorded.', {
                    title: 'Email Warning',
                    variant: 'warning',
                    solid: true
                });
            }
        },
        goToSubscriptionPage() {
            console.log('Navigating to subscription page');
            this.$router.push('/subscription');
        },
        dismissSubscriptionAlert() {
            this.dismissedSubscriptionAlert = true;
            this.hasNewSubscription = false;
        },
        goToClientProfile() {
            this.$router.push('/client');
        },
        dismissNeeurofitAlert() {
            this.hasNewNeeurofitReport = false;
            const clientId = this.$root.currentUser[0]?.crb5c_client?.crb5c_fow_customerid;
            if (clientId) {
                localStorage.setItem(`lastSeenNeeurofitReport_${clientId}`, new Date().toISOString());
            }
        },
        async checkForNewNeeurofitReports() {
            try {
                const clientId = this.$root.currentUser[0]?.crb5c_client?.crb5c_fow_customerid;
                if (!clientId) return;
                const { data } = await this.$root.axios.get(`/neeurofit/${clientId}`);
                const reports = Array.isArray(data) ? data : [];
                if (!reports.length) return;
                const latest = reports.reduce((a, b) =>
                    new Date(a.createdon) > new Date(b.createdon) ? a : b
                );
                const lastSeen = localStorage.getItem(`lastSeenNeeurofitReport_${clientId}`);
                if (!lastSeen || new Date(latest.createdon) > new Date(lastSeen)) {
                    this.hasNewNeeurofitReport = true;
                }
            } catch (error) {
                console.error('Error checking for new Neeurofit reports:', error);
            }
        },
    },
    computed: {
        visibleQuickActions() {
            const fowOnly = ['/make-up-session', '/submit-mc'];
            return this.quickActions.filter(a => !fowOnly.includes(a.path) || this.fowEligible === true);
        },
        loadingImage: {
            get() {
                return this.$store.state.loadingImage;
            },
            set(value) {
                this.$store.commit('setLoadingImage', value);
            }
        },
        validImageUrl() {
            return this.$store.state.groupPhoto;
        },
        caregiverName() {
            return this.$store.state?.caregiver?.name
        },
        caraClientId() {
            return this.$root.currentUser[0]?.crb5c_client?.crb5c_fow_customerid;
        },
        caraCaregiverId() {
            return this.$root.currentUser[0]?.crb5c_fow_caregiverid;
        },
        canPromptCara() {
            return !this.showOpeningPopup
                && !this.showUnpaidSubscriptionPopup
                && !this.showModal
                && !this.permissionModalOpen
                && !this.$root.isMaintenanceMode;
        },
        caregiverEmail() {
            return this.$store.state?.caregiver?.email || '';
        },
        emailValidation() {
            if (!this.sendEmailCopy || !this.recipientEmail) return null;
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(this.recipientEmail);
        },
        isValidEmail() {
            if (!this.sendEmailCopy) return true;
            if (this.caregiverEmail && !this.recipientEmail) return true;
            return this.emailValidation === true;
        },
        timeOfDayGreet() {
            let hour = this.$root.dayjs().hour();
            return hour < 12 ? 'Morning' : hour < 13 ? 'Afternoon' : 'Evening';
        },
        ...mapState({
            caregiver: state => state.caregiver,
        }),
        lastAnnouncements() {
            let cloned = JSON.parse(JSON.stringify(this.$root.announcements));
            const ann = cloned?.sort((a, b) => {
                if (a.dateUpdated >= b.dateUpdated) {
                    return 1;
                } else {
                    return -1;
                }
            }).slice()
            return ann.reverse().slice(0, 3);
        },
        currentClientName() {
            return this.$store.state.cli_name;
        },
        currentClientId() {
            return this.$store.state.cli_id
        },
        currentCaregiverId() {
            return this.$store.state.currentUser[0].crb5c_fow_caregiverid
        }
    },
    async created() {
        // FIX: only run when after login, if the token exist, dont run this.
        // await this.$root.loginAndFetch();
    },
    async mounted() {
         
        this.loadingAnnouncements = true;
       
        this.$nextTick(() => {
            const anim = this.$refs.anim?.anim;
            if (anim) {
                setTimeout(() => {
                    anim.goToAndPlay(150, true);
                }, 500);
            } else {
                console.error('Lottie animation not found');
            }
        });
        

        const imageReady = Promise.resolve()
            .then(() => this.reloadImage())
            .catch(err => console.error('Error loading image', err))
            .finally(() => { this.loadingImage = false; });

        const haveUser = await this.waitForCurrentUser();

        if (haveUser) {

            this.recordLoginVisit();

            await Promise.all([
                this.loadFreeSubscriptions(),
                this.checkForNewSubscriptions(),
                this.checkForNewNeeurofitReports(),
                this.loadAnnouncements(),
                this.checkConsentRecord(),
            ]);
        } else {
            console.error('Timed out waiting for the current user record');
            this.loadingAnnouncements = false;
        }

        await imageReady;




        this.notificationOn = localStorage.getItem("notificationEnabled");
        // console.log('notificationOn',this.notificationOn)

        if(this.notificationOn === null){
            // First run — the user hasn't decided yet, so prompt.
            this.showPermissionModal();
        }else if(this.notificationOn === 'true'){
            // Previously enabled — verify it's still valid and re-link.
            await this.checkNotificationPermission();
        }
        // 'false' => the user explicitly turned notifications off (in Settings);
        // respect that and do not prompt again here.

        // Sync the banner to the real OneSignal state, and keep it fresh when the
        // user returns to the app or changes the setting elsewhere.
        this.refreshNotificationState();
        this._notifRefresh = () => {
            if (document.visibilityState === 'visible') this.refreshNotificationState();
        };
        document.addEventListener('visibilitychange', this._notifRefresh);
        window.addEventListener('focus', this._notifRefresh);
        try {
            this.$OneSignal.Notifications.addEventListener('permissionChange', this.refreshNotificationState);
            this.$OneSignal.User.PushSubscription.addEventListener('change', this.refreshNotificationState);
        } catch (e) { /* SDK may not be ready */ }

        // The consent check now runs alongside the other startup requests in
        // checkConsentRecord(), rather than after the notification setup.
    },
    beforeDestroy() {
        document.removeEventListener('visibilitychange', this._notifRefresh);
        window.removeEventListener('focus', this._notifRefresh);
        try {
            this.$OneSignal.Notifications.removeEventListener('permissionChange', this.refreshNotificationState);
            this.$OneSignal.User.PushSubscription.removeEventListener('change', this.refreshNotificationState);
        } catch (e) { /* listeners may not have been attached */ }
    },
    inject: ["users", "announcements", "reminders"],
};
</script>

<style lang="scss" scoped>
.main-container {
    height: 90vh;
    width: 100%;
    overflow-y: scroll;

    .greeting-container {
        height: 15vh;
    }
    .quick-actions-container{
        width: 100%;


    }

}

/* Greeting text */
.greet-label {
    color: #9b8bb0;
    font-weight: 500;
    margin-bottom: 0;
}
.greet-name {
    color: #4a3866;
    font-weight: 700;
    margin-bottom: 0;
}

/* Section headings with accent bar */
.section-heading {
    position: relative;
    font-weight: 700;
    color: #4a3866;
    padding-left: 0.9rem;

    &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 1.1em;
        border-radius: 4px;
        background: linear-gradient(180deg, #C68FE6, #8967B3);
    }
}

/* Hero image card */
.hero-card {
    border: none;
    border-radius: 18px;
    overflow: hidden;
    box-shadow: 0 10px 28px rgba(137, 103, 179, 0.28);
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 14px 34px rgba(137, 103, 179, 0.34);
    }

    ::v-deep .card-img {
        border-radius: 18px;
        min-height: 210px;
        object-fit: cover;
    }

    ::v-deep .card-img-overlay {
        padding: 1.25rem 1.4rem;
        background: linear-gradient(
            180deg,
            rgba(74, 56, 102, 0) 35%,
            rgba(74, 56, 102, 0.35) 65%,
            rgba(40, 28, 60, 0.78) 100%
        );
    }
}

#card-overlay {
    .hero-badge {
        display: inline-block;
        align-self: flex-start;
        font-size: 0.68rem;
        font-weight: 600;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        padding: 0.2rem 0.6rem;
        margin-bottom: 0.5rem;
        border-radius: 999px;
        background: rgba(255, 255, 255, 0.22);
        backdrop-filter: blur(4px);
        color: #fff;
    }
    .hero-title {
        font-weight: 700;
        margin-bottom: 0.15rem;
        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
    }
    .hero-subtitle {
        font-size: 0.85rem;
        margin-bottom: 0;
        opacity: 0.92;
        text-shadow: 0 1px 6px rgba(0, 0, 0, 0.35);
    }
}

.skeleton-image {
    border-radius: 18px;
}

.loading{
    height: 90vh;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.notif-off-banner {
    cursor: pointer;
    padding: 0.85rem 1rem;
    border-radius: 12px;
    background: #fff4e5;
    border: 1px solid #ffe0b2;
    color: #8a5a00;
    transition: background 0.2s ease;

    &:hover, &:active {
        background: #ffecd1;
    }

    .notif-off-icon {
        font-size: 1.3rem;
        color: #e69500;
        flex-shrink: 0;
    }
    h6 {
        font-weight: 700;
        color: #8a5a00;
    }
    small {
        opacity: 0.9;
        line-height: 1.2;
    }
    .notif-off-chevron {
        flex-shrink: 0;
        opacity: 0.6;
    }
}
.image-gallery-container{
    gap: 1rem;
    .img-cont{
        width: 100%;
        position: relative;
        
        img{
            border-radius: 10px;
            border: 1px solid #8967b3;
        }
        button{
            position: absolute;
            bottom: 0;
            right: 0;
        }

    }
}

.subscription-alert {
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    animation: shake 2s ease-in-out infinite;
    
    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        transform: translateY(-2px);
        animation: none; // Stop animation on hover
    }
}

@keyframes shake {
    0%, 100% {
        transform: translateX(0);
    }
    10%, 30% {
        transform: translateX(-5px);
    }
    20%, 40% {
        transform: translateX(5px);
    }
    50%, 90% {
        transform: translateX(0);
    }
}

</style>
